import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import FieldGroup from './FieldGroup'

class LoginModal extends Component {
  updateLogin = e => {
    return this.props.updateLogin({ login: e.target.value });
  }

  updatePassword = e => {
    return this.props.updatePassword({ password: e.target.value });
  }

  loginUser = e => {
    e.preventDefault();
    return this.props.loginUser({
      username: this.props.loginForm.login,
      password: this.props.loginForm.password,
    });
  }

  render() {
    if (this.props.loginModalState === 'close') {
      return null;
    }

    const { message, isRequest } = this.props.loginForm;

    return (
      <div className="static-modal">
        <Modal show={true}>
          <form onSubmit={this.loginUser}>
            <Modal.Header closeButton onHide={this.props.toggleLoginModal}>
              <Modal.Title>Вход</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <FieldGroup disabled={isRequest ? true : false} onChange={this.updateLogin} id="login" type="text" label="E-mail" placeholder="Введите ваш email..." />
              <FieldGroup disabled={isRequest ? true : false} onChange={this.updatePassword} id="password" type="password" label="Пароль" placeholder="Введите ваш пароль..." />
              {message ? (<div className="alert alert-danger">{message}</div>) : null}
            </Modal.Body>

            <Modal.Footer>
              <Button disabled={isRequest ? true : false} type="submit" bsStyle="primary">Войти</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

export default LoginModal;



// WEBPACK FOOTER //
// ./src/components/LoginModal.js